import type { VFC } from "react";

type Props = {
  unreadCount: number;
};

export const UnreadCountBadge: VFC<Props> = ({ unreadCount }) => {
  const count = 9 < unreadCount ? "9+" : unreadCount;
  return <span className="notificationCenter__unreadCountBadge">{count}</span>;
};
